import { DEFAULT_RADIUS_KM } from '@/constants'

import { isExpandedCoordinatesSearch } from './isExpandedCoordinatesSearch'

type BuildExpandedDestinationLabelArgs = {
  regionName?: string
  useExpandedCoordinates?: boolean | string
  ne?: string
  sw?: string
}

/**
 * AS-2729: on the expanded-polygon page the destination reads
 * "<regionName> + 10km". Once the user switches to the map and moves it, the
 * search becomes a map-area search (identified by an ne/sw bounding box) and the
 * region label becomes "Map area" — at which point the "+ 10km" suffix is
 * misleading, so we drop it and fall back to the plain region label.
 */
export const buildExpandedDestinationLabel = ({
  regionName,
  useExpandedCoordinates,
  ne,
  sw,
}: BuildExpandedDestinationLabelArgs): string | undefined => {
  const isMapAreaSearch = Boolean(ne && sw)

  return isExpandedCoordinatesSearch(useExpandedCoordinates) &&
    regionName &&
    !isMapAreaSearch
    ? `${regionName} + ${DEFAULT_RADIUS_KM}km`
    : regionName
}
